
import { autoinject } from "aurelia-framework";
import { I18N } from "aurelia-i18n";

@autoinject
export class HumidityFormatValueConverter {

	constructor(private i18n: I18N) { }
	toView(humidity: number) {

		if (humidity === null || humidity === undefined || isNaN(humidity)) {
			return this.i18n.tr("offline");
		}
		if (isNaN(humidity)) {
			return null;
		}
		return `${humidity.toFixed(1)} % RH`;
	}
}